/**
 * /support/macros. Owner only.
 *
 * Editing a macro is Tier 3, because the text reaches customers, and every save writes a
 * version row so a wording change is auditable without reading the audit log.
 */
import { createRoute } from '@tanstack/react-router';
import { Route as shellRoute } from '../_shell';
import { Card, Pill, Skeleton } from '@/features/customers/temp-ui';
import { useMacros } from '@/features/support/api';

function MacrosPage() {
  const macros = useMacros();
  if (macros.isLoading) return <Skeleton shape="text" lines={6} />;
  return (
    <Card title="Macros">
      <p style={{ color: 'var(--text-muted)' }}>
        Editing a macro needs a fresh passkey confirmation and a typed MACRO, because the text goes to customers.
      </p>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {(macros.data?.items ?? []).map((macro) => (
          <li
            key={macro.macro_id}
            style={{ padding: 'var(--space-2) 0', borderBottom: 'var(--border-width) solid var(--border)' }}
          >
            <strong>{macro.name}</strong> <Pill>v{macro.version}</Pill>{' '}
            {macro.is_active ? null : <Pill tone="warn">inactive</Pill>}
            <p style={{ color: 'var(--text-muted)', margin: 0, whiteSpace: 'pre-wrap' }}>
              {macro.body_email.slice(0, 160)}
            </p>
          </li>
        ))}
      </ul>
    </Card>
  );
}

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/support/macros',
  component: MacrosPage,
});
